/**
 * @step 1741: statics data only for monoDash like languages and available consoles
 * @type {{Languages: [{name: string, id: string, direction: string},{name: string, id: string, direction: string},{name: string, id: string, direction: string}]}}
 */
export const StaticsData = {
    Languages: [
        {
            name: "English",
            id: 'en',
            direction: "ltr"
        },
        {
            name: "فارسی",
            id: 'fa',
            direction: "rtl"
        },
        {
            name: "عربي",
            id: 'ar',
            direction: "rtl"
        }
    ]
}
